import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ActNowHttp } from "../act-now.http";


import { environment } from "../../environments/environment";
import { ProgramListViewModel, DataTablesQuery, ResponseMessage, ProgramFilter } from "@models/common";
import { Program, ProgramPublicProfile } from "@models/program";
import { DeleteRequest } from "@models/requests";
import { ActNowDictionaryItem } from "@models/common";


@Injectable()
export class ProgramService {
    public apiUrl: string = environment.apiUrl;
    private headers = new Headers({ "Content-Type": "application/json", "Accept": "application/json;charset=UTF-8" });

    constructor(private http: Http, private actnowHttp: ActNowHttp) { }

    // #region Admin Only
    programMergeQuery(request: string): Observable<ActNowDictionaryItem[]> {
        return this.actnowHttp.get(this.apiUrl + "Program/ProgramMergeFilter?request=" + request)
            .map((response: Response) => {
                return response.json();
            })
            .catch(this.handleError);
    }
    getProgram(id: number): Observable<Program> {
        return this.actnowHttp.get(this.apiUrl + "Program/Get/" + id)
            .map((response: Response) => <Program>response.json())
            .catch(this.handleError);
    }
    programListQuery(request: DataTablesQuery): Observable<ProgramListViewModel> {
        return this.actnowHttp.post(this.apiUrl + "Program/Filter/", JSON.stringify(request))
            .map((response: Response) => {
                return response.json();
            })
            .catch(this.handleError);
    }
    saveProgram(model: Program): Observable<ResponseMessage> {
        return this.actnowHttp.post(this.apiUrl + "Program/Edit", JSON.stringify(model))
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }
    createProgram(model: Program): Observable<ResponseMessage> {
        return this.actnowHttp.post(this.apiUrl + "Program/Create", JSON.stringify(model))
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }
    deleteProgram(id: number): Observable<ResponseMessage> {
        return this.actnowHttp.delete(this.apiUrl + "Program/" + id)
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }
    mergePrograms(program1: ActNowDictionaryItem, program2: ActNowDictionaryItem): Observable<ResponseMessage> {
        return this.actnowHttp.post(this.apiUrl + "Program/Merge/", JSON.stringify({ SourceId: program1.id, DestinationId: program2.id }))
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    exportPrograms(filter: ProgramFilter): Observable<string> {
        return this.actnowHttp.post(this.apiUrl + "Program/Export", JSON.stringify(filter))
            .map((response: Response) => <string>response.json())
            .catch(this.handleError);
    }
    // #endregion

    // #region Public
    getSelectLists(): Observable<any> {
        return this.http.get(this.apiUrl + "Program/GetAllSelectLists/", { headers: this.headers })
            .map((response: Response) => {
                return response.json();
            })
            .catch(this.handleError);
    }
    getProgramPublicProfile(id: number): Observable<ProgramPublicProfile> {
        return this.http.get(this.apiUrl + "Program/PublicProfile/" + id, { headers: this.headers })
            .map((response: Response) => <ProgramPublicProfile>response.json())
            .catch(this.handleError);
    }
    // #endregion

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || "Server Error");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/programs/program.service.ts